import React from 'react'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

class ScrollToTop extends React.Component {
  componentDidMount() {
    // delay p/ evitar o history automatic scroll restoration...
    _.delay(() => window.scrollTo(0, 0), 1000)
  }

  render() {
    return null
  }
}

export default withRouter(ScrollToTop)
